import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BaseInterface,
  ExtendedBaseInterface,
  ISearchRequest,
} from 'src/app/store/Authentication/auth.models';
import { environment } from 'src/environments/environment';

const env = environment.API_URL;

@Injectable({ providedIn: 'root' })
export class MarketedPropertiesService {
  constructor(private http: HttpClient) {}

  getMarketedProperties(data: ISearchRequest) {
    const formData = new FormData();
    formData.append('PageNumber', data.PageNumber.toString());
    formData.append('PageSize', data.PageSize.toString());
    formData.append('SortColumn', data.SortColumn || '');
    formData.append('SortOrder', data.SortOrder || '');
    formData.append('Search', data.Search || '');

    return this.http.post<ExtendedBaseInterface>(
      `${env}MarketedProperty/Admin/GetListings`,
      formData,
    );
  }

  approveMarketedProperty(id: number, comments: string) {
    return this.http.post<BaseInterface>(
      `${env}MarketedProperty/Approve/${id}?comments=${encodeURIComponent(comments)}`,
      '',
    );
  }

  rejectMarketedProperty(id: number, rejectionReason: string) {
    return this.http.post<BaseInterface>(
      `${env}MarketedProperty/Reject/${id}`,
      {
        rejectionReason,
      },
    );
  }
}
